import { isBrowser } from './is-browser';
export function isNewTheme() {
  if (isBrowser()) {
    return !!document.cookie.split('; ').find(row => row.startsWith('newfont'));
  }
  return null;
}